export default __webpack_public_path__ + "static/media/processor_samplefile.744dad71.csv";